import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "notes-header-wrapper -pxy_2" }
const _hoisted_2 = {
  key: 0,
  class: "text-content-loading mr-4 flex !size-10 items-center justify-center !rounded-full"
}

import { computed } from 'vue'
import type { UserGender } from '@/types/app-data/user.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotesHeader',
  props: {
    picture: {},
    vip: { type: Boolean },
    highRisk: { type: Boolean },
    gender: {},
    name: {}
  },
  setup(__props: any) {

const props = __props

const loading = computed(() => !props.name)

return (_ctx: any,_cache: any) => {
  const _component_sword_icon = _resolveComponent("sword-icon")!
  const _component_profile_picture = _resolveComponent("profile-picture")!
  const _component_sword_button_wuk = _resolveComponent("sword-button-wuk")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_sword_icon, {
            name: "profile",
            class: "!text-context-5"
          })
        ]))
      : (_openBlock(), _createBlock(_component_profile_picture, {
          key: 1,
          class: "mr-4",
          size: "md",
          "show-vip-icon": __props.vip,
          "show-high-risk-icon": __props.highRisk,
          picture: __props.picture,
          gender: __props.gender
        }, null, 8, ["show-vip-icon", "show-high-risk-icon", "picture", "gender"])),
    _createElementVNode("span", {
      class: _normalizeClass(["t2 -t_medium", {'text-content-loading': loading.value}])
    }, _toDisplayString(__props.name), 3),
    _createVNode(_component_sword_button_wuk, {
      class: "close-button",
      theme: "text",
      round: "",
      size: "small",
      icon: "close",
      onClickNative: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    })
  ]))
}
}

})